module.exports = __webpack_public_path__ + "static/como-lavar-2175b5d6606de0686477683b71a3e75c.webp";